import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  ru: {
    error: {
      openLater: 'Произошла ошибка, мы уже работаем над устранением данный проблемы. Пожалуйста оставьте ваши координаты в форме обратной связи, чтобы мы могли сообщить вам о возобновлении работы сервиса!',
      reloadPage: 'Произошла ошибка сетевого соединения, пожалуйста обновите страницу.',
      contactsAgain: 'Произошла ошибка сетевого соединения, контактные данные не были найдены.',
      placeAgain: 'Произошла ошибка сетевого соединения, пожалуйста запросите еще раз информацию о рекламном месте.',
      changeEmail: 'Произошла ошибка сетевого соединения, пожалуйста попробуйте еще раз изменить E-mail.',
      confirmEmail: 'Произошла ошибка сетевого соединения, пожалуйста попробуйте еще раз перейти по ссылке в письме.',
      changePassword: 'Произошла ошибка сетевого соединения, пожалуйста попробуйте еще раз изменить Пароль.',
      passwordNotConfirmed: 'Существующий пароль не подтвержден. Пожалуйста, введите правильный пароль и повторите попытку.',
      removeConfirmedSidesWithOperator: 'Нельзя удалить оператора, т.к. в нем есть подтвержденные стороны. Отказаться от них можно только через тех. поддержку.',
      removeConfirmedSidesWithList: 'Нельзя удалить заказ, т.к. в нем есть подтвержденные стороны. Отказаться от них можно только через тех. поддержку.',
      removeConfirmedSidesWithListByDesignMasterUser: 'Нельзя удалить заказ, т.к. в нем есть подтвержденные стороны. Обратитесь за снятием сторон к ДДП региона',
      recoverPasswordEmailNotFound: 'Логин не найден. Попробуйте другой логин e-mail, или пройдите регистрацию.',
      passwordWasConfirmedLater: 'Пароль уже был подтвержден. Повторное подтверждение недопустимо.',
      timeIsUpToConfirmPassword: 'Истекло время на подтверждение смены пароля. Пожалуйста, повторите процедуру смены пароля на форме авторизации.',
      recoverPasswordUserIsBlocked: 'Логин заблокирован, пожалуйста, обратитесь в службу поддержки.',
      recoverPasswordUserIsAnonym: 'Логин заблокирован, пожалуйста, обратитесь в службу поддержки.',
      recoverPasswordEmailIsEmpty: 'У логина отсутствует e-mail. Пожалуйста, обратитесь в службу поддержки.',
      createNewUser: 'Не удалось создать нового пользователя. Пожалуйста, повторите попытку.',
      createdUserWasConfirmed: 'Данный пользователь уже прошел проверку, повторная проверка недопустима.',
      userIsExistWithEmail: 'Пользователь с данным именем email уже существует.',
      userIsBlocked: 'Пользователь с данным именем email заблокирован. Пожалуйста обратитесь в службу поддержки.',
      emailNotConfirmed: 'Неверный пароль. Пожалуйста, введите правильный пароль и повторите попытку.',
      userExistInDataBase: 'В базе уже есть пользователь с данным e-mail. Обратитесь в службу поддержки.',
      canNotRemoveIssueSides: 'Нельзя удалять подтвержденные стороны.',
      changeProfileContacts: 'Произошла ошибка сетевого соединения, пожалуйста попробуйте еще раз изменить контактные данные.',
      invalidOrder: 'Не удалось подтвердить адресную программу, т.к. закончилось время бронирования и стороны были зарезервированы другим пользователем. Пожалуйста воспользуйтесь кнопкой замены сторон и вернитесь к подтверждению адресной программы.',
      failedOrder: 'Нельзя оформить документ, пока в корзине есть РП, находящиеся на согласовании цен.',
      requireHelpError: 'Произошла ошибка сетевого соединения, пожалуйста отправьте форму повторно.',
      accreditationFilesSendError: 'Произошла ошибка сетевого соединения, пожалуйста отправьте файлы повторно.',
      sideConfirmFailed: 'Произошла ошибка сетевого соединения, пожалуйста попробуйте подтвердить сторону еще раз.',
      paymentTermsNotUpdated: 'Не все данные обновились. Проверьте обновленный список.',
      sidesProlongFailed: {
        1: 'Не удалось продлить, т.к. стороны были зарезервированы другим пользователем. Пожалуйста нажмите кнопку заменить стороны.',
        2: 'Не удалось продлить %d стороны.',
        5: 'Не удалось продлить %d сторон.',
        otherError: 'Не удалось продлить стороны из-за проблем с сетевым соединением. Пожалуйста попробуйте повторить операцию еще раз.'
      },
      sidesReplaceFailed: {
        1: 'Не удалось заменить.',
        2: 'Не удалось заменить %d стороны.',
        5: 'Не удалось заменить %d сторон.',
        otherError: 'Не удалось заменить стороны из-за ошибки сетевого соединения. Пожалуйста попробуйте повторить операцию еще раз.'
      },
      sidesRemoveFailed: {
        1: 'Не удалось удалить.',
        2: 'Не удалось удалить %d стороны.',
        5: 'Не удалось удалить %d сторон.',
        otherError: 'Не удалось удалить стороны из-за ошибки сетевого соединения. Пожалуйста попробуйте повторить операцию еще раз.'
      },
      sidesRemoveFailedIfItsWasConfirmed: {
        1: 'Не удалилась подтвержденная сторона. Отказаться от нее можно только через менеджера, обратиться в техподдержку.',
        2: 'Не удалились %d подтвержденные стороны. Отказаться от них можно только через менеджера, обратиться в техподдержку.',
        5: 'Не удалились %d подтвержденныx сторон. Отказаться от них можно только через менеджера, обратиться в техподдержку.',
        otherError: 'Не удалились подтвержденные стороны. Отказаться от них можно только через менеджера, обратиться в техподдержку.'
      },
      sidesAddFailed: {
        1: 'Не удалось добавить РП в корзину, т.к. оно уже забронировано в другом заказе. Пожалуйста выберите другое РП!',
        2: 'Не удалось добавить %d стороны.',
        5: 'Не удалось добавить %d сторон.',
        otherError: 'Не удалось добавить стороны из-за проблем с сетевым соединением. Пожалуйста попробуйте повторить операцию еще раз.'
      },
      freeSidesToAdd: {
        1: 'В корзину было добавлено только %d свободное РП, т.к остальные были уже забронированы в другом заказе. Пожалуйста выберите другие РП!',
        2: 'В корзину было добавлено только %d свободных РП, т.к остальные были уже забронированы в другом заказе. Пожалуйста выберите другие РП!',
        5: 'В корзину было добавлено только %d свободных РП, т.к остальные были уже забронированы в другом заказе. Пожалуйста выберите другие РП!',
      },
      removaAllChecked: {
        1: 'Из корзины будет удалена %d строка.',
        2: 'Из корзины будет удалено %d строки.',
        5: 'Из корзины будет удалено %d строк.',
      },
      removeSidesInCartByDesignMaster: {
        1: 'Не удалилась подтвержденная сторона. Обратитесь за снятием сторон к ДДП региона.',
        2: 'Не удалились %d подтвержденные стороны. Обратитесь за снятием сторон к ДДП региона.',
        5: 'Не удалились %d подтвержденных сторон. Обратитесь за снятием сторон к ДДП региона.'
      },
      removeSidesInCartByAnotherUser: {
        1: 'Не удалилась подтвержденная сторона. Отказаться от нее можно только через менеджера, обратиться в техподдержку',
        2: 'Не удалились %d подтвержденные стороны. Отказаться от нее можно только через менеджера, обратиться в техподдержку',
        5: 'Не удалились %d подтвержденных сторон. Отказаться от них можно только через менеджера, обратиться в техподдержку'
      },
      customText: '',
      customTextAndReload: ''
    }
  }
};

export default new VueI18n({
  locale: 'ru',
  messages
});
